import Layout from "components/layout";
import SEO from "components/seo";
import DocumentTranslationServices from "components/reusableComponents/staticPages/documentTranslationServices.js";
import React from "react";

export default function Index() {
  const title = "Document Translation Services | Tomedes";
  const description =
    "Tomedes provides fast, accurate document translation services in over 100 languages, for business translation customers around the world.";
  const keywords = "Professional Document Translation Services | Tomedes";
  const slug = "/document-translation-services";

  return (
    <Layout>
      <SEO
        title={title}
        description={description}
        keywords={keywords}
        slug={slug}
      />
      <DocumentTranslationServices />
    </Layout>
  );
}
